module.exports = __webpack_public_path__ + "static/img/bg38.a7642f7b.png";